import { JsonInput, LoadingOverlay } from '@mantine/core';
import { useEffect, useState } from 'react';

import { embedGetChunk } from '@mygpt/app';

import { getUrlHashParams } from '@/utils/helper';

const DebugChunksPage = () => {
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);

  const initData = async () => {
    const { bot_id, url, file_id } = getUrlHashParams();
    const res = await embedGetChunk({ aiId: bot_id, url, fileId: file_id });
    setValue(JSON.stringify(res.data, null, 2));
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    initData();
  }, []);

  return (
    <div>
      <LoadingOverlay visible={loading} />
      <JsonInput
        className="m-2"
        variant="unstyled"
        formatOnBlur
        autosize
        minRows={10}
        value={value}
        autoComplete="off"
      />
    </div>
  );
};

export default DebugChunksPage;
